import { FC, useRef } from 'react';
import { SvgIcon, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { ReactComponent as ChatIcon } from 'src/assets/svg/chat.svg';

import { useContactModalStore } from '../../rebooking/store';

import { ContactUsButton } from './contact-us-button';

export const ZendeskLiveChatButton: FC = () => {
    const { closeModal } = useContactModalStore();

    const { t } = useTranslation();
    const Icon = useRef(
        <SvgIcon>
            <ChatIcon />
        </SvgIcon>
    );

    return (
        <ContactUsButton
            icon={Icon.current}
            onClick={() => {
                if (typeof window.zE !== 'function') return;
                window.zE('messenger', 'open');
                closeModal();
            }}
        >
            <Typography>{t('contact_us_live_chat')}</Typography>
        </ContactUsButton>
    );
};
